import type { FC } from 'react';
import { Studio } from '@/components/studio/index.tsx';

export const StudioDetailPage: FC = () => <Studio />;
